export default __webpack_public_path__ + "static/media/class-1.f2538839.jpg";